// extracted by mini-css-extract-plugin
export var dividerNavbar = "g4_pQ";
export var loginSignupLink = "g4_pP";
export var navMenuSecondary = "g4_pN";